export default {"src":"/_next/static/media/link.d315f6c8.svg","height":20,"width":20,"blurWidth":0,"blurHeight":0};